<template>
  <div class="agency-commission">
    <div class="agency-commission__top">
      <router-link :to="{ name: 'Agencies' }" class="agency-commission__back">
        <i class="tim-icons icon-minimal-left"></i> Back to partners
      </router-link>
      <h3 class="agency-commission__title">
        Commission — {{ partnerName }}
        <small class="agency-commission__id">#{{ id }}</small>
      </h3>
    </div>

    <agency-commission-terms :agency-id="id" @currency-change="currencyCode = $event" />
    <agency-commission-rules :agency-id="id" :currency-code="currencyCode" />
  </div>
</template>

<script>
import agencyAccess from '@/components/Agencies/agencyAccess';
import { mapState } from 'vuex';
import AgencyCommissionTerms from '@/components/Agencies/Commission/AgencyCommissionTerms.vue';
import AgencyCommissionRules from '@/components/Agencies/Commission/AgencyCommissionRules.vue';

export default {
  mixins: [agencyAccess],
  components: { AgencyCommissionTerms, AgencyCommissionRules },
  props: {
    agencyId: { type: [String, Number], required: true },
  },
  data: () => ({
    currencyCode: '',
  }),
  created() { this.$store.dispatch('agencies/refreshPermissions'); },
  computed: {
    ...mapState('agencies', ['agencies']),
    id() {
      return Number(this.agencyId);
    },
    // There is no "get agency by id" endpoint in cms-api, so the name comes from the partners list
    // already in the store, or from the `name` query the list's Commission button adds (survives
    // a reload/deep link).
    partnerName() {
      const agency = (this.agencies || []).find((a) => a.id === this.id);
      const fromStore = agency && agency.name && agency.name.en;
      return fromStore || this.$route.query.name || `Partner #${this.id}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.agency-commission {
  &__top {
    margin-bottom: 16px;
  }

  &__back {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    margin-bottom: 8px;
  }

  &__title {
    margin: 0;
  }

  &__id {
    color: #8898aa;
    font-size: 14px;
    margin-left: 6px;
  }
}
</style>
